export default __webpack_public_path__ + "static/media/portfolioRatios_screenshot.3c8735c4.png";